exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form[data-v-308e08ce]{width:100%;max-width:940px;margin:auto;padding:2rem 1rem;border-radius:5px;border:1px solid #f2f3f7;background-color:#fff;position:relative}@media (min-width:575px){form[data-v-308e08ce]{padding:2rem}}", ""]);

// exports
